Drupal.behaviors.competitonFormV1 = {
  attach: function (context, settings) {
    var $competitionForm = $('.competition_form', context);
    var $confirmation = $('.competition_form_confirm', context);

    $("input[name*='PHONE2']").on('input || keyup || mouseup || change', function (event) {
      var value = $(this).val();
      var pos;

      if (value.substr(0, 2) == '04') {
        value = value.replace('04', '614');
        $(this).val(value);
        setCaretPosition($(this).attr('id'), 3);
      } else if ((pos = value.indexOf('-')) != -1) {
        value = value.replace(/-/g, '');
        $(this).val(value);
        setCaretPosition($(this).attr('id'), pos);
      }
    });

    $competitionForm.on('submit', function (event) {
      event.preventDefault();
      // Put the form values into an object
      var paramArr = $competitionForm.serializeArray();
      var paramObj = {};

      $('input,select,textarea,[name=QUESTION]', $competitionForm).removeClass('error');
      $.each(paramArr, function (index, param) {
        paramObj[param.name] = param.value;
      });
      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (jsonRpcResponse) {
          $confirmation.toggle();
          var redirect_value = $('#REDIRECT_URL').val();

          window.location.replace(redirect_value);
        },
        onFailure: function (jsonRpcResponse) {
          var errorObjectsArray = jsonRpcResponse.getMessages();
          var $ulNode = $competitionForm.find('ul.error_messages');

          generic.showErrors(errorObjectsArray, $ulNode, $competitionForm);
          // Select Box support for error messages
          var selectOption = $('select.select-box--replaced');

          if (selectOption.length && selectOption.hasClass('error')) {
            $('.js-select-box').addClass('error');
          } else {
            $('.js-select-box').removeClass('error');
          }
        }
      });
    });
  }
};
